import * as ExcelJS from "exceljs";
import { Combination } from "../../types";
import { saveAs } from "file-saver";
import { autoWidth } from "../../utils";

const EXCEL_COLUMNS: Partial<ExcelJS.Column>[] = [
    { key: "supplier", header: "Supplier" },
    { key: "supplierPort", header: "Supplier Port" },
    { key: "service", header: "Service" },
    { key: "line", header: "Shipping Line" },
    { key: "arrival", header: "Week of Arrival" },
    { key: "rate", header: "Rate Type" },
    { key: "port", header: "Port" },
    { key: "warehouse", header: "WH" },
    { key: "item", header: "Item" },
    { key: "quantity", header: "Quantity to be Arrived" },
    { key: "pallets", header: "# of Pallets to be Arrived" },
    { key: "availablePallets", header: "Available Pallets Capacity" },
    { key: "variable", header: "Variable" },
    { key: "factor", header: "X-Factor" },

    { key: "variableValue", header: "Variable Value" },
    { key: "optimalSolution", header: "Optimal Solution", width: 100 },
];

type ExportExcelParams = {
    combinations: Combination[];
    optimalValue: number;
};

export const exportExcel = async ({ combinations, optimalValue }: ExportExcelParams) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Solution");

    // Add header
    worksheet.columns = EXCEL_COLUMNS;
    // Add data to the worksheet
    combinations.forEach((row) => {
        worksheet.addRow(row);
    });
    // Add optimal value under optimalSolution column
    worksheet.getRow(2).getCell("optimalSolution").value = optimalValue;

    //calculate and set the maximum width based on content for each column except the ones whose width are set
    autoWidth(worksheet, 10, 30);

    const data = await workbook.xlsx.writeBuffer();
    const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
    });

    saveAs(blob, `optimized-network-result-${new Date().toISOString()}.xlsx`);
};
